import "./hotel.css"
import Navbar from "../../components/navbar/Navbar";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import MailList  from "../../components/mailList/MailList";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faCircleArrowRight, faCircleXmark, faLocationDot } from "@fortawesome/free-solid-svg-icons";

 const Hotel = () => {
  const[slideNumber, setSliderNumber] = useState(0);
  const[open, setOpen] = useState(false);
  const photos = [
     {
      src : "https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8aG90ZWwlMjByb29tfGVufDB8fDB8fHww"},
     {
      src : "https://images.unsplash.com/photo-1566195992011-5f6b21e539aa?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fGhvdGVsJTIwcm9vbXxlbnwwfHwwfHx8MA%3D%3D" },
     {
      src : "https://media.istockphoto.com/id/1367378067/photo/modern-bathroom.webp?b=1&s=170667a&w=0&k=20&c=N2wi9Re9fgK_2YFgP6y0EOCdD9rdtlubCQBJ0PVqVWE=" },
     {
      src : "https://images.unsplash.com/photo-1610527003928-47afd5f470c6?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGhvdGVsJTIwa2l0Y2hlbnxlbnwwfHwwfHx8MA%3D%3D" },
     {
      src : "https://images.unsplash.com/photo-1602081115720-72e5b0a254b8?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTV8fGx1eHVyeSUyMGhvdGVsfGVufDB8fDB8fHww"        },
     {
      src : "https://media.istockphoto.com/id/1066999762/photo/3d-rendering-beautiful-luxury-bedroom-suite-in-hotel-with-tv.webp?b=1&s=170667a&w=0&k=20&c=vR8JuaNZA4Q24WuDdE2WPb_7XBJKXCfwBxRF2gea3MY="  },
     
     
   
  ];
  const handleOpen = (i)=>{
    setSliderNumber(i);
    setOpen(true);

  };
  const handleMove = (direction) =>{
    let newSliderNumber;

    if(direction==="l"){
      newSliderNumber = slideNumber === 0 ? 5 : slideNumber-1
    }
    else{
      newSliderNumber = slideNumber === 5 ? 0 : slideNumber+1
    }
    setSliderNumber(newSliderNumber);
  };
  return (
    <div>
      <Navbar/>
      <Header type="list"/>
    <div className="hotelContainer">
        {open && <div className="slider">
    <FontAwesomeIcon icon={faCircleXmark} className="close" onClick ={()=>setOpen(false)}/>
    <FontAwesomeIcon icon={faCircleArrowLeft} className="arrow" onClick={()=>handleMove("l")}/>
    <div className="sliderWrapper">
      <img src={photos[slideNumber].src} alt="" className="sliderImg" />
    </div>
    <FontAwesomeIcon icon={faCircleArrowRight} className="arrow" onClick={()=>handleMove("r")}/>
        </div>}
        <div className="hotelWrapper">
          <button className="bookNow">Reserve or Book Now!</button>
          <h1 className="hotelTitle">Unison Hotel</h1>
          <div className="hotelAddress">
            <FontAwesomeIcon icon={faLocationDot}/>
            <span>Dipo Bahir Dar</span>   
          </div>
          <span className="hotelDistance">
            Excellent location 500m from St. Georgiys
          </span>
          <span className="hotelPriceHighlight">
            Book a stay over $114 at this property and get a free airport taxi
          </span>
          <div className="hotelImages">
            {photos.map((photo,i) =>(
              <div className="hotelImgWrapper">
                <img 
                onClick = {()=>handleOpen(i)} 
                src={photo.src}
                 alt="" 
                 className="hotelImg" />
              </div>
            ))}
          </div>
          <div className="hotelDetails">
            <div className="hotelDetailsTexts">
              <h1 className="hotelTitle">Stay in the heart of Krakow</h1>
              <p className="hotelDesc">
              Located a 5-minute walk from St.Florian's Gate in Krakow, Tower
              Street Apartment has accummodatons with air conditioning and 
              free WiFi. The units come with hardwood floors and features a 
              fully equipped kitchenette with a microwave, a flat-screen TV,
              and a private bathroom with shower and a harddryer. A fridge is
              also offered, as well as an electric tee pot and a coffee 
              machine. Popular points of interest near the apartment include
              Cloth Hall, Main Market Square and Town Hall Tower . The nearest 
              airport is John Paul II from Tower Street apartments, and the property offers a paid 
              airport shuttle service.
              </p>
            </div>
            <div className="hotelDetailsPrice">
              <h1>Perfect for a 9-night stay</h1>
              <span>
                Located in the real heart of Krakov, this propery has an 
                excelent location score of 9.8!
              </span>
              <h2>
                <b>$945</b>(9 nights)
              </h2>
              <button>Reserve or Book Now!</button>
            </div>
          </div>
        </div>
        <MailList/>
        <Footer/>
      </div>
    </div>
  )
}
 export default Hotel;